import React from 'react';
import PropTypes from 'prop-types';

export const Icon = ({
    iconClassName = '',
    icon = 'question',
    color = 'primary',
    className = '',
    size = 'lg',
    type = 'd'
}) => {
    return (
        <span key={Math.random()} className={`icon ${className}`}>
            <i className={`fa${type} fa-${icon} fa-${size} text-${color} ${iconClassName}`}></i>
        </span>
    );
};

Icon.propTypes = {
    iconClassName: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
    type: PropTypes.string
};
